var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * One editable component of a composed subfield (`100 $a` Příjmení, `$d` Rok narození, …)
 * laid out like every other subfield row: `[code slot] | label | input` (CZNA-1376).
 *
 * The code slot stays empty — the component belongs to the `$a` / `$d` printed in the row
 * above it — but keeps its width, so the label lands in the same column as the labels of
 * the plain subfields. Until CZNA-1376 the components sat in a `Row`/`Col` grid with the
 * label ABOVE each input, which read as a second kind of field on the same panel.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes/components';
import { subfieldRowStyle, subfieldCodeStyle, subfieldLabelStyle, subfieldActionsStyle, } from './subfieldStyles';
/**
 * Baseline, not the plain rows' `center`: a component input grows a message under it
 * (a component validator's error or warning), and the label belongs next to the
 * input, not halfway down the message.
 */
var rowStyle = __assign(__assign({}, subfieldRowStyle), { alignItems: 'baseline' });
/** A block, not a flex box: the inputs and Stripes' `Datepicker` fill their container's width. */
var inputCellStyle = { flex: 1, minWidth: 0 };
var ComponentRow = function (_a) {
    var inputId = _a.inputId, label = _a.label, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, children = _a.children;
    return (React.createElement("div", { style: rowStyle },
        React.createElement("span", { style: subfieldCodeStyle, "aria-hidden": "true" }),
        React.createElement("label", { htmlFor: inputId, style: subfieldLabelStyle },
            label,
            readOnly && (React.createElement(Icon, { size: "small", icon: "lock" },
                React.createElement("span", { className: "sr-only" },
                    React.createElement(FormattedMessage, { id: "stripes-components.readonly" }))))),
        React.createElement("div", { style: inputCellStyle }, children),
        React.createElement("span", { style: subfieldActionsStyle, "aria-hidden": "true" })));
};
export default ComponentRow;
